// extracted by css-extract-rspack-plugin
export default {"offerBuyCards":"XW_Dw7Au7JAUpCHF"};